import React, { useMemo } from 'react';
import i18n from '@shared/i18n';
import { useBuyerProductStore } from 'app/store/product';
import { type BuyerLayoutProps } from 'shop-ui/types';
import { getDisplayPrice } from 'app/libs/getDisplayPrice';
import STYLE from './ProductInfoGroup.module.scss';

const DISCOUNTED_PRICE = {
    value: 'NT$ 1890',
    amount: '1890',
    currency: 'TWD',
};

const ORIGINAL_PRICE = {
    value: 'NT$ 2100',
    amount: '2100',
    currency: 'TWD',
};

const OFFSET = {
    value: 'NT$ 100',
    amount: '100',
    currency: 'TWD',
};

interface ProductPriceProps extends BuyerLayoutProps {}

export const ProductPrice: React.FC<ProductPriceProps> = (props) => {
    const { isBuyer } = props;

    const { product, selectedProductDetailId } = useBuyerProductStore();

    const displayPrice = useMemo(() => {
        let _product = product;

        if (!_product) {
            _product = {} as Product;

            _product.price = ORIGINAL_PRICE;

            _product.promo_saving_price = OFFSET;

            _product.discounted_price = DISCOUNTED_PRICE;

            _product.spec_details = [];
        }

        const price = isBuyer ? _product.price : ORIGINAL_PRICE;

        const offset = isBuyer ? _product.promo_saving_price : OFFSET;

        const discountedPrice = isBuyer ? _product.discounted_price : DISCOUNTED_PRICE;

        const chooseSpecDetail = _product.spec_details.find(
            (i) => i.id === selectedProductDetailId
        );

        const nonSpecProductPrice = getDisplayPrice({
            originalPrice: price,
            discountedPrice,
            promoSavingPrice: offset,
            minAddOnPrice: null,
        });

        if (chooseSpecDetail) {
            const specProductPrice = getDisplayPrice({
                originalPrice: chooseSpecDetail.price,
                discountedPrice: chooseSpecDetail.discounted_price,
                promoSavingPrice: chooseSpecDetail.promo_saving_price,
                minAddOnPrice: null,
            });

            return specProductPrice;
        }

        return nonSpecProductPrice;
    }, [product, selectedProductDetailId, isBuyer]);

    return (
        <div className={STYLE.priceBox}>
            {displayPrice.useDiscountedPrice && displayPrice.discountedPrice && (
                <span className={STYLE.price}>{displayPrice.discountedPrice.value}</span>
            )}
            <b className={STYLE.price}>{displayPrice.originalPrice?.value}</b>
            {displayPrice.promoSavingPrice && (
                <div className={STYLE.discountBox}>
                    <span className={STYLE.badge}>
                        {i18n.gettext('省下')} {displayPrice.promoSavingPrice.value}
                    </span>
                </div>
            )}
        </div>
    );
};
